import { TimeUnit, ReversedDurations } from "@avenueops/shared-types";

export type TimeUnitValue = {
  unit: TimeUnit;
  value: number;
};

export default function secondsToTimeUnitValue(seconds: number): TimeUnitValue | undefined {
  if (!seconds) {
    return undefined;
  }

  for (const option of ReversedDurations) {
    if (seconds % option.seconds === 0) {
      return {
        unit: option.unit,
        value: seconds / option.seconds,
      };
    }
  }

  return {
    unit: TimeUnit.SECONDS,
    value: seconds,
  };
}
